import { createListPage } from 'pages/common/ListPage';
import { createTable } from 'pages/common/ListTable';
import { createForm } from 'pages/common/Form';

import { selectors, actions } from 'domain/substrate';
import { filterParams } from 'filters/substrate';

import { tableParams, columns } from 'fields/substrate';

const { list: items, onInlineEdit: edit, selected: selectedItems, loading, pagination } = selectors;
const { selectAction, inlineEditAction: onEdit, createItemAction, updateItemAction } = actions;

const Table = createTable({
  tableName: 'substrateList',
  tableParams,
  updateItemAction,
  allowEdit: () => true,
  connections: {
    items,
    toggleRowCheck: selectAction,
    toggleAllSelected: selectAction,
    selectedItems,
    edit,
    onEdit,
    loading,
    pagination,
  },
});

export const Form = createForm({
  form: 'addSubstrate',
  action: createItemAction,
  formFields: columns.select('description','rank','order'),
});

export default createListPage({
  name: 'Substrate',
  pagination,
  filterParams,
  Table,
  Form,
});
